import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
} from '@efexteam/components';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Alert, Box, Divider, IconButton, Typography } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { referrer } from '../../../../assets';
import useBoolean from '../../../../hooks/useBoolean';
import { selectProfileData } from '../../../../pages/profile/store/selectors';
import { SideBarStyles } from './Sidebar.styles';

const Referrer = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const [showReferralCode, { setFalse: hideModal, setTrue: showModal }] =
    useBoolean(false);
  const [successCopied, setSuccessCopied] = useState(false);
  const [errorCopied, setErrorCopied] = useState(false);
  const userProfile = useSelector(selectProfileData);
  const referrerCode = useMemo(
    () => userProfile?.company.referrerCode,
    [userProfile?.company.referrerCode]
  );

  const copyCode = async () => {
    try {
      await navigator.clipboard.writeText(referrerCode || '');
      setSuccessCopied(true);
    } catch (err) {
      console.error('Failed to copy: ', err);
      setErrorCopied(true);
    }
  };

  useEffect(() => {
    if (successCopied || errorCopied) {
      setTimeout(() => {
        setSuccessCopied(false);
        setErrorCopied(false);
      }, 2500);
    }
  }, [successCopied, errorCopied]);

  useEffect(() => {
    if (searchParams.get('action') === 'referral') {
      showModal();
      searchParams.delete('action');
      setSearchParams(searchParams);
    }
  }, [searchParams, setSearchParams, showModal]);

  return (
    <div className={SideBarStyles.box}>
      <Box className={SideBarStyles.referrerWrapper}>
        <img
          className={SideBarStyles.referrerImage}
          src={referrer}
          alt="referrer icon"
        />
        <Typography className={SideBarStyles.referrerHeader} variant="body1">
          ¡{t('referrerNavTitle')}!
        </Typography>
        <Typography className={SideBarStyles.referrerMessage} variant="body1">
          <span className={SideBarStyles.referrerBoxMessage}>
            {t('referrerNavMessage1')}
            <span className={SideBarStyles.referrerMessageAmmount}>
              {t('referrerNavMessageAmmount')}
            </span>
            {t('referrerNavMessage2')}
          </span>
        </Typography>
        <Button
          className={SideBarStyles.referrerButton}
          appearance="secondary"
          onClick={showModal}
        >
          {t('referrerNavButton')}
        </Button>
      </Box>

      <Dialog
        open={showReferralCode}
        onClose={hideModal}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          className={SideBarStyles.referrerModalTitle}
          showCloseButton
          onClick={hideModal}
        >
          {t('referrerModalTitle') || ''}
        </DialogTitle>
        <DialogContent>
          <Typography
            className={`${SideBarStyles.referrerMessage} bg-[rgba(201,239,201,0.5)] py-1 px-2 flex items-center rounded mb-5 text-center`}
            variant="body2"
          >
            {t('referrerNavMessage')}
          </Typography>
          <Box>
            <Typography variant="h6" className="text-center !mt-4">
              {t('referrerModalCode')}
            </Typography>
            <div className={SideBarStyles.referrerModalCodeWrapper}>
              <p>{referrerCode}</p>
              <IconButton color="primary" onClick={copyCode}>
                <ContentCopyIcon />
              </IconButton>
            </div>
            {errorCopied && (
              <Alert className="my-3" severity="error">
                {t('referrerModalError')}
              </Alert>
            )}
            {successCopied && (
              <Alert className="my-3" severity="success">
                {t('referrerModalSuccess')}
              </Alert>
            )}
            <Divider />
            <div className={SideBarStyles.referrerModalEarns}>
              <Typography variant="body2">{t('referrerModalEarns')}</Typography>
              <Typography variant="body1">
                $0.00 <span>USD</span>
              </Typography>
            </div>
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Referrer;
